import { createSafeContext } from '@mews-framework/utils';
import { LoggerService } from './createLoggerService';

const { LoggerServiceContextProvider, useLoggerServiceContext } = createSafeContext<
    'LoggerServiceContext',
    LoggerService
>('LoggerServiceContext');

export const useLoggerService = useLoggerServiceContext;

export const createLoggerServiceProvider =
    <P,>(loggerService: LoggerService) =>
    (props: P) => <LoggerServiceContextProvider value={loggerService} {...props} />;
